export const REFUND_TITLES = {
    DEPOSIT_REFUNDED_FULL: 'Deposit Refund',
    DEPOSIT_REFUNDED_PARTIAL: 'Deposit Refund',
    BALANCE_REFUNDED_FULL: 'Balance Refund',
    BALANCE_REFUNDED_PARTIAL: 'Balance Refund',
    CANCELLATION_REFUND: 'Cancellation Refund',
    RECONCILIATION_REFUND: 'Refund'
};
